import WORKOUT_EXERCISES_PATH from '../../constants/path'
import { createSelector } from 'reselect'
import { getObjectUtil } from 'packages/src'

const getCurrentWorkoutExerciseSelect = createSelector(
  state => getObjectUtil(state, WORKOUT_EXERCISES_PATH.DATA),
  state => getObjectUtil(state, WORKOUT_EXERCISES_PATH.CURRENT),
  (workoutExercisesDomainMap, id) => {
    return workoutExercisesDomainMap[id]
  }
)

export default getCurrentWorkoutExerciseSelect
